import { combineReducers } from '@reduxjs/toolkit'

import { transactionsProcess } from '.'

export const transactions = combineReducers({
  transactions: transactionsProcess.reducer,
})
